import { injectIntl } from 'react-intl';
import * as types from './types';
import { actionForState } from '../../../utils/helpers';

const initialAction = {
  success: false,
  loading: false,
  error: false
};

const INITIAL_STATE = {
  gross_receipts: {},
  fetchReceiptsAction: {
    success: false,
    loading: false,
    error: false
  },

  contractsAction: {
    success: false,
    loading: false,
    error: false
  },
  fetchDirectoryDetailAction: {
    success: false,
    loading: false,
    error: false
  },
  createRecieptAction: initialAction
};


// eslint-disable-next-line func-names
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    /* ******************************** */
    /*         LOAD ASSET TYPES         */
    /* ******************************** */
    case types.GET_GROSS_RECIEPTS.pending:
      return {
        ...state,
        fetchRecieptsAction: actionForState(state.action, 'pending')
      };
    case types.GET_GROSS_RECIEPTS.success:
      return {
        ...state,
        gross_receipts: action.payload,
        fetchRecieptsAction: actionForState(state.action, 'success')
      };
    case types.GET_GROSS_RECIEPTS.error:
      return {
        ...state,
        fetchRecieptsAction: actionForState(state.action, 'error')
      };
      case types.GET_GROSS_RECIEPT_DETAIL.pending:
      return {
        ...state,
        fetchRecieptsAction: actionForState(state.action, 'pending')
      };
    case types.GET_GROSS_RECIEPT_DETAIL.success:
      return {
        ...state,
        gross_receipts_detail: action.payload,
        fetchRecieptsAction: actionForState(state.action, 'success')
      };
    case types.GET_GROSS_RECIEPT_DETAIL.error:
      return {
        ...state,
        fetchRecieptsAction: actionForState(state.action, 'error')
      };


      case types.GET_CONTRACTS.pending:
        return {
          ...state,
          contractsAction: actionForState(state.action, 'pending')
        };
      case types.GET_CONTRACTS.success:
        return {
          ...state,
          gross_contracts: action.payload,
          contractsAction: actionForState(state.action, 'success')
        };
      case types.GET_CONTRACTS.error:
        return {
          ...state,
          contractsAction: actionForState(state.action, 'error')
        };
    case types.CREATE_GROSS_RECIEPTS.pending:
      return {
        ...state,
        createRecieptAction: actionForState(state.action, 'pending')
      };
    case types.CREATE_GROSS_RECIEPTS.success:
      return {
        ...state,
        schemas: action.payload,
        createRecieptAction: actionForState(state.action, 'success')
      };
    case types.CREATE_GROSS_RECIEPTS.error:
      return {
        ...state,
        createRecieptAction: actionForState(state.action, 'error')
      };

    case types.GROSS_RECIEPTS_CLEAR_ACTION:
      return {
        ...state,
        fetchReceiptsAction: { loading: false, success: false, error: false },
        createRecieptAction: { loading: false, success: false, error: false }
      };

    default:
      return injectIntl(state);
  }
}
